module.exports = __webpack_public_path__ + "img/document.3b12ebbf.svg";